// 必須項目を示す小さなバッジ。フォームのラベル横に置く。
export function RequiredBadge() {
  return (
    <span className="ml-2 inline-flex items-center rounded bg-blue-100 px-1.5 py-0.5 text-xs font-medium text-blue-700">
      必須
    </span>
  );
}
